import { render, staticRenderFns } from "./Testsheet.vue?vue&type=template&id=1564d625"
import script from "./Testsheet.vue?vue&type=script&lang=js"
export * from "./Testsheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports